import axios from "axios";
import { Component } from "react";
import GeneralBloc from "../bloc/general_bloc";
import BaseWebService from "./base_web_service";
import DOMPurify from "dompurify";

export default class ContactServices extends Component {
  //newContact
  static async newContact() {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/client/new`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //No use
  static async newModule(module) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/${module}/new`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getContact details
  static async getContact(id) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/client/detail`);
    let resp = await axios.post(
      url,
      {
        id:id
      },
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //generateQuotation
  static async generateQuotation(id) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/quotation/generate?quotationId=${id}`);
    let resp = await axios.get(
      url,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //saveContact details
  static async saveContact(payload) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/client/update`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //generateDocuments for quotation
  static async generateDocuments(id) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/quotation/generate?quotationId=${id}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //deleteContactById
  static async deleteContactById(id,payload) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/client/delete?id=${id}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //softDeleteClientById when updated old contact with changed in fields
  static async softDeleteClientById(id) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/client/softDeleteClient?clientId=${id}`);
    let resp = await axios.post(
      url,
      {},
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  //getListing for Contact module
  static async getListing(
    payload,
    searchCriteria
  ) {
    let header = await BaseWebService.standardHeaders();
    let url=DOMPurify.sanitize(`${process.env.REACT_APP_BASE_URL_BUSINESS}/client/listing?value=${searchCriteria}`);
    let resp = await axios.post(
      url,
      payload,
      {
        headers: header,
      }
    );
    let response = BaseWebService.baseResponseFromWeb(resp.data);
    return response;
  }

  
}
